import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { submitSalesLeads } from 'utils/api/queries/omantelMicroApi';
import { AjaxResponse } from 'rxjs/ajax';
import { getLanguage } from 'utils/language/language';

export class SubmitSalesLeads extends GenericService {
	//This API is for adding new microbundle for new customer and also for activating the selected services for the returning customer.
	public static submitSalesLeads(data: any): Observable<AjaxResponse> {
		const payload = {
			...data,
			language: getLanguage(),
			sendEmailToUser: true,
			sendSmsToUser: true,
		};
		return submitSalesLeads(payload)
			.withErrorHandling()
			.call();
	}
}
